import { Dropdown, DropdownItem } from "flowbite-react";
import { Label } from "../../forms/Label";
import { useTranslation } from "react-i18next";

type TMonthDropdownProps = {
  month: string;
  onChange: (month: string) => void;
  monthNames: string[];
};

const MonthDropdown = ({
  month,
  onChange,
  monthNames,
}: TMonthDropdownProps) => {
  const { t } = useTranslation("common");
  return (
    <div className="dropdown-main-section">
      <Label weight={"medium"}>{t("FILTER.MONTH")}</Label>
      <Dropdown
        label={
          month ? monthNames[parseInt(month, 10) - 1] : t("FILTER.SELECT_MONTH")
        }
        dismissOnClick={true}
        size="default"
        className="min-w-[130px] w-full flex justify-between text-left rounded-lg border bg-background px-2 py-2 text-sm text-foreground"
      >
        {monthNames?.map((m, idx) => (
          <DropdownItem
            key={m}
            className="hover:bg-slate-200 text-sm"
            onClick={() => onChange(String(idx + 1).padStart(2, "0"))}
          >
            {m}
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
};

export default MonthDropdown;
